import React from "react";
import "./Header.scss";
import vero from "../../../../assets/images/logo-vibe-vero.png";

const Header = ({ product }) => {
  return (
    <>
      <div className="vero-redemption-code-header">
        <img src={vero} alt={product?.name || "Vero"} />
      </div>
    </>
  );
};

export default Header;
